// extracted by mini-css-extract-plugin
module.exports = {"starsContainer":"ratingStars_starsContainer__UG5og","starIcon":"ratingStars_starIcon__FnNqQ","starFill":"ratingStars_starFill__5F6tK"};